module.exports = __webpack_public_path__ + "static/media/print.6a53ad4a.svg";